import { LoginForm } from '../components/auth/login-form';
import { Seo } from '../components/seo';
import { useAppName } from '../hooks/useAppName';

function LoginPage() {
  const appName = useAppName();

  return (
    <>
      <Seo title="Login" />
      <h4 className="text-black font-inter text-xl leading-6">
        Log in to your
      </h4>
      <h2 className="text-black font-inter text-[2rem] leading-[2.4rem] font-semibold mt-2">
        <span className="font-bold">{appName}</span> Admin
      </h2>
      <div className="mt-[1.125rem]">
        <LoginForm loginRedirect="/orders" />
      </div>
    </>
  );
}

export default LoginPage;
